<!-- 新增商品第一步 -->
<template>
  <div>
    <div class="container" @click="closeSearch">
      <!-- <div class="sort-content">
        <div class="sort-search">
          <div class="sales-scope" :class="'sales-scope-active'">
            <div class="txt">
              <span>销售范围</span>
              <div class="rule-content">
                <el-tooltip class="item" placement="right">
                  <div slot="content">
                    全平台销售：指商品对平台所有采购用户销售，包括协议客户。
                    <br />
                    协议客户销售：指商品只对协议客户以协议价销售，不对协议客户以外的用户销售。如需对全平台销售，请先向申请商品可售类目。
                  </div>
                  <span class="tip-icon">?</span>
                </el-tooltip>
              </div>
            </div>
            <el-radio-group v-model="salesScope" @change="handleSalesScope">
              <el-radio class="isActive" :label="1">
                <img
                  :src="
                    salesScope == 1
                      ? imgList.platformChoice
                      : imgList.platformDefault
                  "
                  alt=""
                />
                向全平台客户销售
              </el-radio>
              <el-radio :label="2">
                <img
                  :src="
                    salesScope == 2
                      ? imgList.agreementChoice
                      : imgList.agreementDefault
                  "
                  alt=""
                />
                向协议客户销售
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div> -->
      <select-product-scope-and-type
        :sales-scope="salesScope"
        :sales-type="salesType"
        @handleSalesScope="handleSalesScope"
        @handleSalesType="handleSalesType"
      ></select-product-scope-and-type>
    </div>
    <div class="container" style="height: calc(100vh - 336px)">
      <!-- <p>{{salesScope==1?'商品可售类目':'商品分类'}}</p> -->
      <div class="sales-scope">
        <p>{{ salesScope == 1 ? '商品可售类目' : '商品分类' }}</p>
        <div class="rule-content" style="display: flex">
          <el-tooltip class="item" placement="right">
            <div slot="content">
              可售类目：可以对全平台用户销售的商品所属的产品目录，需要向平台申请
              <!-- <br />
                    协议客户销售：指商品只对协议客户以协议价销售，不对协议客户以外的用户销售。如需对全平台销售，请先向申请商品可售类目。 -->
            </div>
            <!-- <el-button type="text" icon="el-icon-question"></el-button> -->
            <span class="tip-icon">?</span>
          </el-tooltip>
        </div>
        <p style="color: #999; margin-left: 10px; font-size: 14px">
          <!-- 如在下方类目中没有可选择的可售类目，请先 -->
          请根据客户单位采购需求选择商品类目发布商品
          <!-- <span
            style="color:#2587FF"
            class="pointer"
            @click="goBack('/productDirectoryApply')"
            >新增产品目录;</span
          > -->
        </p>
      </div>
      <div id="searchInput" class="contents">
        <div class="flex" :class="{ isActive: isShowResult }">
          <el-input
            v-model.trim="searchValue"
            class="middle_input"
            size="middle"
            placeholder="请输入最小分类名称或关键字"
            @keyup.enter="goToSearch()"
          ></el-input>
          <p class="middle_btn" @click="goToSearch">查找</p>
          <p class="rest_btn" @click="restSearch">重置</p>
          <div v-show="isShowResult" v-loading="loading" class="search-result">
            <ul v-if="categoryList.length > 0">
              <li
                v-for="item in categoryList"
                :key="item.categoryId"
                @click="selectItem(item)"
              >
                <span
                  v-for="(subitem, index) in item.routeList"
                  :key="subitem.categoryId"
                >
                  <!-- {{ subitem.categoryName}} -->
                  <i v-html="subitem.categoryNameLight"></i>
                  <i v-if="index < item.routeList.length - 1">></i>
                </span>
              </li>
            </ul>
            <div v-else class="no-result">
              <img
                src="../../../../../assets/img/common/icon-empty@2x.png"
                alt=""
              />
              <p class="p-1">抱歉，没找到相关结果</p>
              <p class="p-2">换个搜索词试一试</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="category" v-if="fristCategry.length>0&&(salesScope==1||salesScope==2)"> -->
      <div
        v-if="
          (allCategoryList && allCategoryList.length > 0 && salesScope == 1) ||
          (allCategoryAggrementList && salesScope == 2)
        "
        class="category"
      >
        <div class="item-box">
          <div class="item-input-wrap">
            <el-input
              v-model="input1"
              placeholder="请输入内容"
              class="item-input"
              @input="searchCategory"
              @focus="searchLevel(1)"
            >
              <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt="" > -->
              <img
                slot="suffix"
                class="icon-search"
                :src="imgList.searchDefault"
                alt=""
              />
            </el-input>
          </div>
          <ul>
            <li
              v-for="item in fristCategry"
              :key="item.categoryId"
              class="item-name e-pointer"
              :class="{ active: isForActive1 == item.categoryId }"
              @click="
                showNext(
                  item.categoryId,
                  2,
                  item.isLeaf,
                  item.categoryName,
                  item.children
                )
              "
            >
              <span>{{ item.categoryName }}</span>
              <i class="el-icon-arrow-right"></i>
            </li>
          </ul>
        </div>
        <div v-show="level > 1" class="item-box">
          <div class="item-input-wrap">
            <el-input
              v-model="input2"
              placeholder="请输入内容"
              class="item-input"
              @input="searchCategory"
              @focus="searchLevel(2)"
            >
              <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt=""  > -->
              <img
                slot="suffix"
                class="icon-search"
                :src="imgList.searchDefault"
                alt=""
              />
            </el-input>
          </div>
          <ul>
            <li
              v-for="item in secCategry"
              :key="item.categoryId"
              class="item-name e-pointer"
              :class="{ active: isForActive2 == item.categoryId }"
              @click="
                showNext(
                  item.categoryId,
                  3,
                  item.isLeaf,
                  item.categoryName,
                  item.children
                )
              "
            >
              <span>{{ item.categoryName }}</span>
              <i class="el-icon-arrow-right"></i>
            </li>
          </ul>
        </div>
        <div v-show="level > 2" class="item-box">
          <div class="item-input-wrap">
            <el-input
              v-model="input3"
              placeholder="请输入内容"
              class="item-input"
              @input="searchCategory"
              @focus="searchLevel(3)"
            >
              <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt="" > -->
              <img
                slot="suffix"
                class="icon-search"
                :src="imgList.searchDefault"
                alt=""
              />
            </el-input>
          </div>
          <ul>
            <li
              v-for="item in thirdCategry"
              :key="item.categoryId"
              class="item-name e-pointer"
              :class="{ active: isForActive3 == item.categoryId }"
              @click="
                showNext(
                  item.categoryId,
                  4,
                  item.isLeaf,
                  item.categoryName,
                  item.children
                )
              "
            >
              <span>{{ item.categoryName }}</span>
              <i
                v-if="salesScope == 2 && !item.isLeaf"
                class="el-icon-arrow-right"
              ></i>
              <i
                v-if="
                  salesScope == 1 && item.children && item.children.length > 0
                "
                class="el-icon-arrow-right"
              ></i>
            </li>
          </ul>
        </div>
        <div v-show="level > 3" class="item-box">
          <div class="item-input-wrap">
            <el-input
              v-model="input4"
              placeholder="请输入内容"
              class="item-input"
              @input="searchCategory"
              @focus="searchLevel(4)"
            >
              <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt=""  > -->
              <img
                slot="suffix"
                class="icon-search"
                :src="imgList.searchDefault"
                alt=""
              />
            </el-input>
          </div>
          <ul>
            <li
              v-for="item in forCategry"
              :key="item.categoryId"
              class="item-name e-pointer"
              :class="{ active: isForActive4 == item.categoryId }"
              @click="
                showNext(
                  item.categoryId,
                  5,
                  item.isLeaf,
                  item.categoryName,
                  item.children
                )
              "
            >
              <span>{{ item.categoryName }}</span>
              <!-- <i v-if="!item.isLeaf" class="el-icon-arrow-right"></i> -->
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="category-empty">
        <p>
          您还无可售类目,无法发布对全平台销售的商品，请先
          <span class="pointer" @click="goBack('/productDirectoryApply')"
            >申请可售类目</span
          >
        </p>
      </div>
    </div>
    <div class="btn-box">
      <el-button @click="goBack('/createProduct')">取消</el-button>
      <el-button
        class="next-btn"
        type="primary"
        @click="goToUrl('/createProductsSec')"
      >
        下一步，完善商品信息
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import apiLogin from '@/modules/projectA/api/login/index';
import selectProductScopeAndType from '@/modules/projectA/components/product/productManage/selectProductScopeAndType.vue';
import api from '../../../api/product/index.js';
import utils from '../../../utils/utils';
// import searchCategory from "../../../components/product/productManage/searchCatetory.vue";
export default {
  components: {
    // searchCategory
    selectProductScopeAndType,
  },
  data() {
    return {
      active: 0,
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      fristCategry: [],
      secCategry: [],
      thirdCategry: [],
      forCategry: [],
      isForActive1: null,
      isForActive2: null,
      isForActive3: null,
      isForActive4: null,
      level: 1, //
      isLeaf: 0, // 0-否1-是
      selectCategrayName: '',
      level1name: '',
      level2name: '',
      level3name: '',
      level4name: '',
      isActiveLevel: 0,
      salesScope: 1, // 销售范围
      salesType: 1, // 销售类型
      allCategoryList: [], //
      isShowResult: false,
      searchValue: '',
      categoryList: [],
      categoryListInHighLigth: [],
      loading: false,
      allCategoryAggrementList: true, // 协议list
      imgList: {
        platformChoice: require('../../../../../assets/img/product/icon-platform-choice.png'),
        platformDefault: require('../../../../../assets/img/product/icon-platform-default.png'),
        agreementChoice: require('../../../../../assets/img/product/icon-agreement-choice.png'),
        agreementDefault: require('../../../../../assets/img/product/icon-agreement-default.png'),
        searchDefault: require('../../../../../assets/img/product/icon-search-default.png'),
      },
      getLoginFront: null,
      getLoginRear: null,
    };
  },

  computed: {},

  created() {
    // this.getCategoryList(1, 1);
    this.getCategoryListByAgreement();
    localStorage.removeItem('categoryName');
    this.$setStore('salesScope', this.salesScope);
    this.$setStore('salesType', this.salesType);
  },
  mounted() {
    // 开启延长登录
    this.getLoginActive();
  },
  methods: {
    closeSearch(event) {
      const currentCli = document.getElementById('searchInput');
      if (currentCli) {
        if (!currentCli.contains(event.target)) {
          // 点击到了id为sellineName以外的区域，隐藏下拉框
          this.isShowResult = false;
        }
      }
      // this.isShowResult = false;
    },
    goToSearch() {
      if (utils.deleteSpace(this.searchValue) === '') {
        this.$message.warning('请输入搜索内容');
        return;
      }
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      this.isShowResult = true;
      if (this.salesType === 1) {
        this.getCategroyRouteList(this.searchValue);
      } else {
        this.getNoStandardCategoryRouteList(this.searchValue);
      }

      this.loading = true;
    },
    restSearch() {
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      this.searchValue = null;
      //  this.$emit('restCategoryList');
      this.isShowResult = false;
      this.handleRestCategoryList();
    },
    selectItem(item) {
      this.isShowResult = false;
      //  this.$emit('selectCategoryItem',item);
      this.handleSelectCategory(item);
    },
    // 获取标品搜索路径
    async getCategroyRouteList(name) {
      const res =
        this.salesScope == 1
          ? await api.selectCategoryRouteListByPlatform({ categoryName: name })
          : await api.selectCategoryRouteList({ categoryName: name });

      if (res.code === '200') {
        this.categoryList = res.data;
        // for(let i=0; i<this.categoryList.length; i++){
        //     this.categoryList[i].route = this.categoryList[i].route.split('>');
        // }
        this.addTxtHighLight(this.categoryList, this.searchValue);
        this.loading = false;
        console.log(this.categoryList);
      }
    },
    // 获取非标商品搜索路径
    async getNoStandardCategoryRouteList(name) {
      const res = await api.selectNoStandardCompanyCategoryRouteList({
        categoryName: name,
      });

      if (res.code === '200') {
        this.categoryList = res.data;
        // for(let i=0; i<this.categoryList.length; i++){
        //     this.categoryList[i].route = this.categoryList[i].route.split('>');
        // }
        this.addTxtHighLight(this.categoryList, this.searchValue);
        this.loading = false;
        console.log(this.categoryList);
      }
    },
    // 添加高亮
    addTxtHighLight(arr, key) {
      arr.map((item) => {
        const index = item.routeList.length - 1;
        item.routeList.map((subitem, subIndex) => {
          if (subIndex == index) {
            const replaceReg = new RegExp(key, 'g');
            // 高亮替换v-html值
            const replaceString = `<span class="search-text" style="color:#2587FF">${key}</span>`;
            // 开始替换
            subitem.categoryNameLight = subitem.categoryName.replace(
              replaceReg,
              replaceString
            );
          } else {
            subitem.categoryNameLight = subitem.categoryName;
          }

          // subitem.categoryName = subitem.categoryName.replace(replaceReg, replaceString);
        });
      });
      console.log(arr);
    },
    ...mapMutations(['PRODUCT_LIST', 'PRODUCT_LIST_2', 'addProductList']),

    // 获取搜索列表
    async getCategoryList(id, level) {
      const params = { categoryId: id };
      const res = await api.getCategoryByParentId(params);
      console.log(res);
      if (res.code === '200') {
        if (Number(level) === 1) {
          this.fristCategry = res.data;
        }
        if (Number(level) === 2) {
          this.secCategry = res.data;
        }
        if (Number(level) === 3) {
          this.thirdCategry = res.data;
        }
        if (Number(level) === 4) {
          this.forCategry = res.data;
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取有商品下的类目全树
    async getCategoryListWithProducts() {
      const res = await api.usefulCategoryTree();
      console.log(res);
      this.level = 1;
      this.allCategoryList = res?.data;
      this.fristCategry = this.allCategoryList;
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
    },
    // 获取分类
    async handleSalesScope(val) {
      console.log(this.salesScope);
      this.salesScope = val;
      this.isLeaf = 0;
      this.$setStore('salesScope', val);
      if (Number(this.salesScope) === 1) {
        this.getCategoryListByAgreement();
      } else {
        this.salesType = 1;
        await this.getCategoryListWithProducts();
        // await this.getCategoryList(-1, 1);
        this.level = 1;
        if (this.fristCategry.length === 0) {
          this.allCategoryAggrementList = false;
        }
      }
    },
    // 获取全平台非标商品分类
    async getCategoryListWithOffstandardProducts() {
      const res = await api.selectNoStandardCompanyCategoryList();
      if (res.code === '200') {
        this.level = 1;
        this.allCategoryList = res?.data;
        this.fristCategry = this.allCategoryList;
        this.secCategry = [];
        this.thirdCategry = [];
        this.forCategry = [];
      }
    },
    // 不同商品类别
    handleSalesType(val) {
      console.log(val);
      this.salesType = val;
      this.isLeaf = 0;
      this.$setStore('salesType', val);
      if (Number(val) === 2) {
        this.getCategoryListWithOffstandardProducts();
      } else {
        this.getCategoryListByAgreement();
      }
    },
    // 获取协议客户
    async getCategoryListByAgreement() {
      const res = await api.getCategoryListByAgreement();
      console.log(res);
      this.level = 1;
      this.allCategoryList = res?.data;
      this.fristCategry = this.allCategoryList;
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
    },
    goBack(url) {
      this.$router.push({ path: url });
    },
    goToUrl() {
      if (this.isLeaf != 1) {
        this.$message.warning('请选择末级菜单');
        return;
      }
      let name = '';
      if (this.level4name) {
        name = `${this.level1name}-${this.level2name}-${this.level3name}-${this.level4name}`;
        this.$setStore('categoryNameStr', this.level4name);
      } else {
        name = `${this.level1name}-${this.level2name}-${this.level3name}`;
        this.$setStore('categoryNameStr', this.level3name);
      }
      this.$setStore('categoryName', name);
      const categoryId = this.isForActive4
        ? this.isForActive4
        : this.isForActive3;
      this.$setStore('categoryId', categoryId);
      this.PRODUCT_LIST_2({ salesScope: this.salesScope });
      this.$emit('changeStep', 1);
      // this.$router.push({ path: url });
    },
    showNext(id, level, leaf, name, children) {
      // if (this.salesScope == 2) {
      //   if (leaf !== 1) {
      //     this.level = level;
      //   }
      // }
      if (level < 5 && children != undefined && children.length > 0) {
        this.level = level;
      }

      if (level == 2) {
        this.level1name = name;
        this.thirdCategry = [];
        this.forCategry = [];
        this.isForActive1 = id;
      }
      if (level == 3) {
        this.level2name = name;
        this.forCategry = [];
        this.isForActive2 = id;
      }
      if (level == 4) {
        this.level3name = name;
        this.isForActive3 = id;
      }
      if (level == 5) {
        this.level4name = name;
        this.isForActive4 = id;
      }
      this.PRODUCT_LIST({ id, name });
      // this.$store.commit('addProductList' , { id, name });
      // this.addProductList({ id, name });
      this.isLeaf = leaf;
      console.log(this.$store.state);
      // if (this.salesScope == 2) {
      //   this.getCategoryList(id, level);
      // } else {
      if (level == 2) {
        this.fristCategry.map((item) => {
          if (item.categoryId == id) {
            this.secCategry = item.children;
          }
        });
      }
      if (level == 3) {
        this.secCategry.map((item) => {
          if (item.categoryId == id) {
            this.thirdCategry = item.children;
          }
        });
      }
      if (level == 4) {
        this.thirdCategry.map((item) => {
          if (item.categoryId == id) {
            this.forCategry = item.children ? item.children : [];
          }
        });
        if (this.forCategry.length == 0) {
          this.isLeaf = 1;
          this.level4name = null;
          this.isForActive4 = null;
        }
      }
      if (level == 5) {
        this.isLeaf = 1;
        this.thirdCategry.map((item) => {
          if (item.categoryId == id) {
            this.forCategry = item.children;
          }
        });
      }
      // }
    },

    async searchCategory(val) {
      console.log(this.level);
      if (val == '') {
        if (this.isActiveLevel == 1) {
          if (this.salesScope == 1) {
            await this.getCategoryListByAgreement();
          } else {
            await this.getCategoryListWithProducts();
          }
        }
        if (this.isActiveLevel == 2) {
          // if (this.level == 2) {
          //   this.fristCategry.map((item) => {
          //     if (item.categoryId == this.isForActive1) {
          //       this.secCategry = item.children;
          //     }
          //   });
          // }
          this.secCategry = this.updateCategroyList(
            2,
            this.fristCategry,
            this.isForActive1
          );
        }
        if (this.isActiveLevel == 3) {
          // if (this.level == 3) {
          //   this.secCategry.map((item) => {
          //     if (item.categoryId == this.isForActive2) {
          //       this.thirdCategry = item.children;
          //     }
          //   });
          // }
          this.thirdCategry = this.updateCategroyList(
            3,
            this.secCategry,
            this.isForActive2
          );
        }
        if (this.isActiveLevel == 4) {
          // if (this.level == 4) {
          //   this.thirdCategry.map((item) => {
          //     if (item.categoryId == this.isForActive3) {
          //       this.forCategry = item.children;
          //     }
          //   });
          // }
          this.forCategry = this.updateCategroyList(
            4,
            this.thirdCategry,
            this.isForActive3
          );
        }
      }
      if (this.isActiveLevel == 1) {
        const res = this.fristCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.fristCategry = res;
      }
      if (this.isActiveLevel == 2) {
        const res = this.secCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.secCategry = res;
      }
      if (this.isActiveLevel == 3) {
        const res = this.thirdCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.thirdCategry = res;
      }
      if (this.isActiveLevel == 4) {
        const res = this.forCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.forCategry = res;
      }
    },
    updateCategroyList(level, list, isActiveCode) {
      let currentList = [];
      if (Number(this.level) === Number(level)) {
        list.map((item) => {
          if (item.categoryId == isActiveCode) {
            currentList = item.children;
          }
        });
      }
      return currentList;
    },
    searchLevel(val) {
      console.log(val);
      this.isActiveLevel = val;
    },
    // 展示搜索框选中的分类
    handleSelectCategory(options) {
      console.log(options);
      this.level = options.routeList.length;
      this.fristCategry = options.routeList[0] ? [options.routeList[0]] : [];
      this.secCategry = options.routeList[1] ? [options.routeList[1]] : [];
      this.thirdCategry = options.routeList[2] ? [options.routeList[2]] : [];
      this.forCategry = options.routeList[3] ? [options.routeList[3]] : [];
      this.isForActive1 = options.routeList[0]
        ? options.routeList[0].categoryId
        : null;
      this.isForActive2 = options.routeList[1]
        ? options.routeList[1].categoryId
        : null;
      this.isForActive3 = options.routeList[2]
        ? options.routeList[2].categoryId
        : null;
      this.isForActive4 = options.routeList[3]
        ? options.routeList[3].categoryId
        : null;
      this.level1name = options.routeList[0]
        ? options.routeList[0].categoryName
        : null;
      this.level2name = options.routeList[1]
        ? options.routeList[1].categoryName
        : null;
      this.level3name = options.routeList[2]
        ? options.routeList[2].categoryName
        : null;
      this.level4name = options.routeList[3]
        ? options.routeList[3].categoryName
        : null;
      this.isLeaf = options.routeList[this.level - 1].isLeaf;
      this.PRODUCT_LIST({ id: options.categoryId, name: options.categoryCode });
    },
    // 重置搜索列表
    handleRestCategoryList() {
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
      this.level = 1;
      this.salesScope = 1;
      this.salesType = 1;
      this.getCategoryListByAgreement();
    },
    // 心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      const token = this.$cookies.get('epecToken');
      if (token) {
        const epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        const now = new Date().getTime();
        const time = epecTokenExpiredTime;
        const timeOutIn = null;
        let timeOut = null;
        if (time > now) {
          const interval = time - now;
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../../assets/css/theme.scss';
.isActive::v-deep .el-input__inner {
  border-left: 1px solid $main-col;
  border-top: 1px solid $main-col;
}
.sort-content {
  // padding: 0 30px;
  margin: 20px 0;
  .sort-search {
    display: flex;
    flex-flow: column;
    // align-items: center;
    // margin-bottom: 20px;
    > p {
      color: #000;
      font-size: 16px;
    }
  }
}
.step-container {
  margin: 20px 52px;
}
.btn-box {
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
.category {
  display: flex;
  // justify-content: space-between;
  .item-box {
    // padding: 20px;
    width: 23%;
    margin-right: 20px;
    background: #f8f8f8;
    height: calc(100vh - 480px);
    overflow-y: auto;
    .item-input-wrap {
      margin: 20px 20px 0 20px;
      .icon-search {
        width: 20px;
        margin-top: 5px;
      }
    }
    ul {
      margin-top: 10px;
    }
    .item-name {
      padding: 0 20px;
      height: 30px;
      // line-height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      //  padding: 3px 0;
      font-size: 14px;
      color: #666;
      &.active {
        background: #f4f7ff;
        color: #0064c8;
      }
      &:hover {
        background: #f4f7ff;
      }
    }
  }
}
.category-empty {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    span {
      color: $main-col;
    }
  }
}
.sales-scope {
  display: flex;
  align-items: center;
  .txt {
    display: flex;
    align-items: center;
    margin-right: 20px;
    > span {
      color: #333;
      font-size: 16px;
    }
    .rule-content {
      font-size: 0;
    }
  }
  //  ::v-deep  .el-radio__label {
  //   border: 1px solid #000;
  //     padding: 10px 20px 10px 20px;
  //     margin-left: 13px;
  // }
  .tip-icon {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    color: #c5c5c5;
    font-size: 12px;
    cursor: pointer;
    margin-left: 16px;
    &:hover {
      border: 1px solid #d9d9d9;
      color: #fff;
      background: #d9d9d9;
    }
  }
}
.contents {
  margin: 20px 0;
  .search-result {
    position: absolute;
    background: #fff;
    z-index: 1000;
    top: 40px;
    width: 420px;
    border-left: 1px solid $main-col;
    border-right: 1px solid $main-col;
    border-bottom: 1px solid $main-col;
    ul {
      overflow-y: auto;
      height: calc(100vh - 480px);
    }
    li {
      padding: 18px;
      font-size: 14px;
      line-height: 1;
      &:hover {
        cursor: pointer;
        background: #f4f7ff;
      }
    }
  }
  .flex {
    display: flex;
    position: relative;
    // &>>>.el-input__inner {
    //   border-left: 1px solid $main-col;
    //   border-top: 1px solid $main-col;
    // }
  }
  .middle_input {
    width: 330px;
    //   ::v-deep .el-input__inner {
    //     border: 2px solid #e8b663;
    //     border-right: none;
    //     border-radius: 0;
    //   }
    // border-left: 1px solid $main-col;
    // border-top: 1px solid $main-col;
  }
  //  .middle_input ::v-deep .el-input__inner {
  //       border: 2px solid #e8b663;
  //     border-right: none;
  //     border-radius: 0;
  //  }
  .middle_btn {
    width: 90px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: $main-col;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
  .rest_btn {
    width: 90px;
    height: 40px;
    line-height: 40px;
    color: #333333;
    background: #fff;
    text-align: center;
    cursor: pointer;
    border: 1px solid #c5c5c5;
    margin-left: 20px;
    font-size: 14px;
  }
}
// ::v-deep.el-radio is-checked{
//   width: 120px;
//   height: 40px;
// }
.sales-scope ::v-deep .el-radio__label {
  border: 1px solid #d9d9d9;
  padding: 10px 20px 10px 50px;
  margin-left: 13px;
  position: relative;
  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
}

.sales-scope ::v-deep .is-checked .el-radio__label {
  border: 1px solid #2587ff;
}
// .el-icon-question{
//   width: 18px;
//   height: 18px;
// }
.el-button--small {
  font-size: 14px;
  padding: 7px 15px;
  min-width: 80px;
}
.no-result {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  img {
    width: 100px;
  }
  .p-1 {
    font-size: 16px;
    color: #333;
    margin: 10px 0;
  }
  .p-2 {
    font-size: 14px;
    color: #666;
  }
}
.search-text {
  color: $main-col;
}
.next-btn {
  min-width: 120px;
  margin-left: 30px;
}
.pointer {
  cursor: pointer;
}
</style>
